import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "150px",
        minWidth: "650px",
        width: "650px",
        maxWidth: "650px",
        backgroundColor: "white",
        padding: "10px",
    },
    item_container: {
        display: "grid",
        gridTemplateColumns: "min-content auto",
        gridColumnGap: "10px",
        marginBottom: '20px',
        marginLeft: "10px"
    },
    index: {
        fontSize: "20px",
        fontWeight: "bold",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold"
    },
    participantsContainer: {
        display: "inline",
    },
    participant: {
        display: "inline-block",
        fontSize: "16px"
    },
    amountContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    label: {
        fontWeight: "bold",
        marginRight: "10px"
    },
    yearContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    sponsorContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    titleContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    icon: {
        marginLeft: "auto",
        "&:hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/dialogs/CPGenericDialogStyles.ts